import React, { useCallback } from 'react';

// DEPENDENCIES
import pick from 'lodash/pick';
import { connect} from 'react-redux';
import { compose } from 'redux';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL FUNCTIONS
import { sessionActions } from 'actions';
import { apiFetch } from 'functions';

// CORE COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// GLOBAL COMPONENTS
import Card from 'parts/card/Card';
import Main from 'parts/main/Main';
import Page from 'parts/page/Page';
import Title from 'parts/title/Title';

// MAIN COMPONENT
const Profile = compose(
  connect(
    ({ user }) => ({ user }),
    {updateUser: sessionActions.updateUser}
  )
)(({
  // REDUX STATE
  user,
  // REDUX DISPATCH
  updateUser
})=> {

  // CALLBACKS
  const handleSubmit = useCallback(
    (params, args) => {
      apiFetch({
        ...args,
        params,
        onSuccess: () => {
          updateUser(params);
        }
      })
    },
    [updateUser]
  )

  // RENDER
  return (
    <Main>
      <Title documentTitle="Profile" title="Profile" />
      <Form
        method="PUT"
        endpoint={ENDPOINTS.user.profile}
        initialValues={pick(user, ['first_name', 'last_name', 'email_address'])}
        loadingMessage="Updating Profile"
        successMessage="Profile updated."
        errorMessage="Unable to update profile."
        onSubmit={handleSubmit}
      >
        <Card body={<Form.Body>
          <Form.Control name="first_name" label="First Name" />
          <Form.Control name="last_name" label="Last Name" />
          <Form.Control type="email" name="email_address" label="Email" />
        </Form.Body>} />
        <Page.Buttons>
          <Button.Submit label="Save Profile" icon="checkmark" />
        </Page.Buttons>
      </Form>
    </Main>
  )
})

// EXPORT
export default Profile;
